<template>
  <!-- eslint-disable -->
  <div class="message-item">
    <div class="message-item__settings-wrapper">
      <div class="d-flex align-center">
        <v-text-field
          class="message-item__settings--delay panzoom-ignore"
          v-model="node.delay"
          :label="'Delay'"
          persistent-placeholder
          :placeholder="'2000'"></v-text-field>
      </div>
    </div>

    <v-text-field
      class="mb-3 panzoom-ignore"
      v-model.number="node.totalTypingTimeMs"
      type="number"
      min="0"
      :label="$t('shortcodes.live_chat_mp4.total_typing_time_ms')"
      persistent-placeholder
      :placeholder="$t('shortcodes.live_chat_mp4.total_typing_time_placeholder')"></v-text-field>

    <!-- MP4-specific: step video -->
    <VaVideoFileInput
      v-model="node.mp4Url"
      :file-id.sync="node.mp4FileId"
      class="mb-3 panzoom-ignore"
      :label="$t('shortcodes.live_chat_mp4.step_mp4_url')" />
    <div v-if="node.mp4Url" class="d-flex align-center mb-3">
      <v-text-field
        class="panzoom-ignore mr-3"
        v-model.number="node.videoOffsetX"
        type="number"
        :label="$t('shortcodes.live_chat_mp4.video_offset_x')"
        persistent-placeholder
        placeholder="0"></v-text-field>
      <v-text-field
        class="panzoom-ignore"
        v-model.number="node.videoOffsetY"
        type="number"
        :label="$t('shortcodes.live_chat_mp4.video_offset_y')"
        persistent-placeholder
        placeholder="0"></v-text-field>
    </div>

    <v-btn v-if="!showEditor" class="d-flex" text outlined @click="showEditor = true"> Content Edit </v-btn>

    <div v-if="!showEditor">
      <div class="content-preview-label">Content preview</div>
      <div>
        <div class="text-left content-preview" v-html="node.content"></div>
      </div>
    </div>

    <va-tinymce-input
      v-if="showEditor"
      ref="tinymce"
      class="mb-4 w-full"
      :current-content="node.content"
      :editor-height="120"
      live-chat-message-preset
      title="Message"
      :forced-root-block-attrs="{ class: 'live-chat-message' }"
      auto-resize
      @update="content => updateMessageContent(content)" />

    <v-text-field
      class="message-item__settings--cssclass panzoom-ignore"
      v-model="node.cssClass"
      :label="'Class'"
      persistent-placeholder
      :placeholder="''"></v-text-field>
    <v-checkbox
      v-if="$can('view', 'live chat ringba parameters')"
      class="mb-3"
      :label="'Ringba replace script'"
      v-model="node.hasRingbaScript"
      color="primary"
      hide-details="auto"
      @change="hasRingbaScriptChange">
    </v-checkbox>

    <code-input
      v-if="node.hasRingbaScript"
      class="panzoom-ignore ringba-script-input mb-3"
      v-model="node.ringbaScript"
      :title="'Ringba script'"></code-input>

    <VaAudioFileInput
      :label="'Audio file'"
      :file-id="fileId"
      @update:file="updateAudioFile"
      :file-name="fileName"
      :file-url="fileUrl"></VaAudioFileInput>
  </div>
</template>

<script>
  import CodeInput from "@/components/custom/CodeInput";
  import VaAudioFileInput from "@/components/custom/VaAudioFileInput";
  import VaVideoFileInput from "@/components/custom/VaVideoFileInput";
  import { AUDIO_FILE } from "./constant";

  export default {
    name: "LiveChatMp4Message",
    components: { CodeInput, VaAudioFileInput, VaVideoFileInput },
    props: {
      node: {
        type: Object,
        required: true,
      },
      isLastMessage: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        showEditor: !this.node?.content,
      };
    },
    computed: {
      fileId() {
        return this.node?.audio?.fileID || "";
      },
      fileName() {
        return this.node?.audio?.fileName || "";
      },
      fileUrl() {
        return this.node?.audio?.fileURL || "";
      },
    },
    methods: {
      updateContent(content) {
        if (this.$refs.tinymce) {
          this.$refs.tinymce.updateContent(content);
        }
      },
      updateAudioFile(fileData) {
        if (fileData) {
          this.$set(this.node, "audio", {});
          this.node.audio.fileID = fileData["@id"];
          this.node.audio.fileURL = fileData.contentUrl;
          this.node.audio.fileName = fileData.fileName;
        } else {
          this.node.audio = { ...AUDIO_FILE };
        }
      },
      hasRingbaScriptChange(val) {
        if (!val) {
          this.node.ringbaScript = "";
        }
      },
      updateMessageContent(content) {
        this.node.content = content;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .ringba-script-input {
    text-align: left;
  }
</style>
